const hasValue = value => value !== null && value !== undefined && String(value).trim() !== '';

export const workflowStartUrl = currentWorkflowDefinition => {
  const params = new URLSearchParams();
  if (hasValue(currentWorkflowDefinition?.version)) {
    params.set('version', currentWorkflowDefinition.version);
  }

  const query = params.toString();
  return `/workflow-definitions/${currentWorkflowDefinition.id}/start${query ? `?${query}` : ''}`;
};

export const workflowStartFormUrl = currentWorkflowDefinition => {
  const params = new URLSearchParams();
  if (hasValue(currentWorkflowDefinition?.version)) {
    params.set('version', currentWorkflowDefinition.version);
  }

  const query = params.toString();
  return `/api/workflow-definitions/${currentWorkflowDefinition.id}/start-form${query ? `?${query}` : ''}`;
};

export const workflowHasStartForm = workflowStartForm => workflowStartForm === true;

const api = (input, init = {}) => import(/* webpackChunkName: "fetch-with-timeout" */ './fetchWithTimeout')
    .then(module => module.api(input, init));

const loadWorkflowRunModal = () => import(/* webpackChunkName: "workflow-run-modal" */ './workflowRunModal');

const showWorkflowRunModal = (currentWorkflowDefinition, workflowName, dependencies = {}) =>
    (dependencies.loadWorkflowRunModal || loadWorkflowRunModal)()
        .then(module => module.workflowRunModal(currentWorkflowDefinition, workflowName));

export const workflowRun = (currentWorkflowDefinition, workflowName, dependencies = {}) => {
  const redirectToStartForm = () => {
    window.location = workflowStartUrl(currentWorkflowDefinition);
  };

  return (dependencies.api || api)(workflowStartFormUrl(currentWorkflowDefinition), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
    },
  }).catch(() => false).then(workflowStartForm => {
    if (workflowHasStartForm(workflowStartForm)) {
      redirectToStartForm();
      return null;
    }

    return showWorkflowRunModal(currentWorkflowDefinition, workflowName, dependencies);
  });
};
